import crudFactory from "../crudFactory.ts";

// Using dynamic model parameter to create reusable Template APIs
export default (model: string) => {
  const COMMON_CRUD_APIs = crudFactory(model);
  return { ...COMMON_CRUD_APIs };
};
